<template>
  <v-dialog
    v-model="dialogOpen"
    max-width="600"
    :persistent="saving"
    :transition="null"
    hide-overlay
  >
    <v-overlay :z-index="0" @click.native="close" />
    <v-card>
      <v-container fluid>
        <v-row>
          <v-col class="title flex-grow-0 flex-shrink-1 text-no-wrap col-12 col-sm-auto">
            Enter Debt
          </v-col>
          <v-col class="text-center text-sm-right">
            <!--<v-select
              v-model="type"
              :items="[
                {
                  text: 'Mortgage',
                  value: 'mortgage'
                },
                {
                  text: 'Auto',
                  value: 'auto'
                },
                {
                  text: 'Credit Card',
                  value: 'credit'
                },
                {
                  text: 'Other Loan',
                  value: 'other'
                }
              ]"
              hide-details
              label="Type"
              dense
              outlined
              :disabled="saving"
            ></v-select>-->
            <v-btn-toggle 
              mandatory 
              v-model="type"
              active-class="primary darkButtonPrimary"
            >
              <v-btn small value="other">
                <v-icon small>mdi-bank</v-icon>
                <div>Other</div>
              </v-btn>
              <v-btn small value="mortgage">
                <v-icon small>mdi-home</v-icon>
                <div>Mortgage</div>
              </v-btn>
              <v-btn small value="auto">
                <v-icon small>mdi-car</v-icon>
                <div>Auto</div>
              </v-btn>
              <v-btn small value="credit">
                <v-icon small>mdi-credit-card</v-icon>
                <div>Card</div>
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" >
            <v-text-field
              v-model="name"
              outlined
              label="Name"
              hide-details
              dense
              :disabled="saving"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="balance"
              outlined
              label="Balance"
              hide-details
              dense
              :disabled="saving"
              placeholder="0"
            />
          </v-col>
          <v-col cols="3">
            <v-menu
              ref="balanceAsOfMenu"
              v-model="balanceAsOfMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="balance_as_of_formatted"
                  label="Balance As Of"
                  hide-details
                  dense
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  @blur="balance_as_of = parseDate(balance_as_of_formatted)"
                  :placeholder="$moment().format('MM/YYYY')"
                ></v-text-field>
              </template>
              <v-date-picker v-model="balance_as_of" no-title scrollable @input="balanceAsOfMenu = false" type="month"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="interest_rate"
              outlined
              label="Interest Rate"
              hide-details
              dense
              :disabled="saving"
              placeholder="0"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="minimum_payment"
              outlined
              label="Min Payment"
              hide-details
              dense
              :disabled="saving"
              placeholder="0"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="actual_payment"
              outlined
              label="Actual Payment"
              hide-details
              dense
              :disabled="saving"
              :placeholder="(minimum_payment ? minimum_payment + '' : '0')"
            />
          </v-col>
          
        </v-row>
        <v-row v-show="type == 'other' || type == 'mortgage'" class="align-center">
          <v-col cols="12" class="pb-0">
            <v-checkbox
              v-model="interest_only"
              label="Interest Only"
              hide-details
              class="my-2"
            ></v-checkbox>
          </v-col>
          <v-col v-if="interest_only" class="pt-0">
            <v-card color="grey lighten-3">
              <v-container fluid class="py-0">
                <v-row>
                  <v-col cols="6">
                    <v-menu
                      ref="debtStartMenu"
                      v-model="debtStartMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="loan_start_date_formatted"
                          label="Loan Start Month"
                          hide-details
                          dense
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          @blur="loan_start_date = parseDate(loan_start_date_formatted)"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="loan_start_date" no-title scrollable @input="debtStartMenu = false" type="month">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="loan_months"
                      label="Loan Length (Months)"
                      hide-details
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="interest_only_months"
                      label="Interest Only Length (Months)"
                      hide-details
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" @click="close()" :disabled="saving">Cancel</v-btn>
        <v-btn color="primary" @click="saveDebt" :loading="saving"><v-icon class="mr-2">mdi-content-save</v-icon>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DebtAdd',
  props: {
    householdId: {
      type: Number,
      required: true
    },
    debtId: Number
  },
  data () {
    return {
      dialogOpen: false,

      name: null,
      type: null,
      cardType: null,
      balance: null,
      balance_as_of: null,
      balance_as_of_formatted: null,
      minimum_payment: null,
      actual_payment: null,
      interest_rate: null,

      interest_only: false,
      loan_months: null,
      interest_only_months: null,
      loan_start_date: null,
      loan_start_date_formatted: null,

      debtStartMenu: false,
      balanceAsOfMenu: false,

      saving: false
    }
  },
  mounted () {
    this.reset()
  },
  watch: {
    dialogOpen (newVal) {
      if(newVal) {
        this.$emit('on-open')
        this.reset()
      } else {
        this.$emit('on-close')
      }
    },
    type ( newVal ) {
      if(newVal != 'mortgage' && newVal != 'other') {
        this.interest_only      = false
        this.payments_remaining = null
        this.loan_start_date    = null
      }
    },
    loan_start_date ( newVal ) {
      this.loan_start_date_formatted = this.formatDate( newVal )
    },
    balance_as_of ( newVal ) {
      this.balance_as_of_formatted = this.formatDate( newVal )
    }
  },
  computed: {
    routeDebtId () {
      return this.$route.params.debt_id
    },
  },
  methods: {
    open () {
      this.dialogOpen = true
    },
    close () {
      this.dialogOpen = false
    },
    reset () {
      if(this.routeDebtId || this.debtId) {
        let debtId  = (this.routeDebtId || this.debtId)

        this.saving = true;
        this.$http.get('debts/' + debtId)
          .then(response => {
            this.name                   = response.data.name
            this.type                   = response.data.type
            this.balance                = response.data.balance
            this.minimum_payment        = response.data.minimum_payment
            this.actual_payment         = response.data.actual_payment
            this.interest_rate          = response.data.interest_rate
            this.balance_as_of          = this.$moment(response.data.balance_as_of).format('YYYY-MM')
            this.interest_only          = (response.data.interest_only ? true : false)
            this.loan_months            = response.data.loan_months
            this.interest_only_months   = response.data.interest_only_months
            this.loan_start_date        = (response.data.interest_only ? this.$moment(response.data.start_date).format('YYYY-MM') : null)
          })
          .catch((err) => {
            if(err.response.status == 401) return

            this.$swal.fire('Error', 'There was an error loading the debt', 'error')
            this.$emit('on-close')
          })
          .finally(() => {
            this.saving = false
          })
      } else {
        this.name                     = null
        this.type                     = 'other'
        this.cardType                 = null
        this.balance                  = null
        this.balance_as_of            = null
        this.minimum_payment          = null
        this.actual_payment           = null
        this.interest_rate            = null
        this.interest_only            = false
        this.loan_start_date          = null
        this.loan_months              = null
        this.interest_only_months     = null

        this.saving                   = false

      }
    },
    saveDebt () {
      this.saving = true;
      let balAsOf = (this.balance_as_of ? this.balance_as_of + '-05' : this.$moment().format('YYYY-MM') + '-05')
      let data = {
        name:                 this.name,
        type:                 this.type,
        balance:              this.balance,
        balance_as_of:        balAsOf,
        minimum_payment:      this.minimum_payment,
        actual_payment:       this.actual_payment,
        interest_rate:        this.interest_rate,
        household_id:         this.householdId,
        interest_only:        (this.interest_only ? 1 : 0),
        loan_months:          (this.interest_only ? this.loan_months : null),
        interest_only_months: (this.interest_only ? this.interest_only_months : null),
        start_date:           (this.interest_only ? this.loan_start_date + '-05' : null)
      }

      

      if(this.routeDebtId || this.debtId) {
        let debtId  = (this.routeDebtId || this.debtId)

        this.$http.put('debts/' + debtId, data)
          .then(response => {
            this.$emit('on-save', response.data);
            this.close()
          })
          .catch(err => {
            if(err.response.status == 401) return
            
            let message = ''
            if(err.response.status == 422) {
              message = ':<br><br>'
              for(let i = 0; i < err.response.data.length; i++) {
                message += '<b>' + err.response.data[i].message + '</b><br>'
              }
            }
            console.log('Debt Error: ', err.response);
            this.$swal.fire({
              title: 'Error', 
              html: 'There was an issue saving the debt' + message, 
              type: 'error'
            });
          })
          .finally(() => {
            this.saving = false;
          })
      } else {
        this.$http.post('debts', data)
          .then(response => {
            this.$emit('on-save', response.data)
            this.close()
          })
          .catch(err => {
            if(err.response.status == 401) return
            
            let message = ''
            if(err.response.status == 422) {
              message = ':<br><br>'
              for(let i = 0; i < err.response.data.length; i++) {
                message += '<b>' + err.response.data[i].message + '</b><br>'
              }
            }
            console.log('Debt Error: ', err.response);
            this.$swal.fire({
              title: 'Error', 
              html: 'There was an issue saving the debt' + message, 
              type: 'error'
            });
          })
          .finally(() => {
            this.saving = false;
          })
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      let [month, year, year2] = date.split('/')
      if(year2) year = year2
      return `${year}-${month.padStart(2, '0')}`
    },
  }
}
</script>

<style lang="scss">
  .darkButtonPrimary {
    .v-btn__content {
      i {
        color: #FFF !important;
      }
      color: #FFF !important;
    }
  }
</style>